/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Away_Clear_Ocelot_RoarInputs */

const fr_away_clear_ocelot_roar = /** @type {(inputs: Away_Clear_Ocelot_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active les notifications`)
};

/**

* @param {Away_Clear_Ocelot_RoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const away_clear_ocelot_roar = /** @type {((inputs?: Away_Clear_Ocelot_RoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Away_Clear_Ocelot_RoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_away_clear_ocelot_roar(inputs)
});